import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "../fetchOrchestrators";

export function onboardingStarted(
  state:
    | IFtthOrchestrator["state"]
    | IMobileOrchestrator["state"]
    | IMultiOrderOrchestrator["state"]
    | IFSecureOrchestrator["state"],
) {
  return state !== "START";
}
